export const TOGGLE_THEME = "TOGGLE_THEME"
export const ADD_MOVIES_BOOKMARK = "ADD_MOVIES_BOOKMARK"
export const ADD_TV_SERIES_BOOKMARK = "ADD_TV_SERIES_BOOKMARK"
export const GET_MOVIES_BOOKMARK = "GET_MOVIES_BOOKMARK"
export const GET_TV_SERIES_BOOKMARK = "GET_TV_SERIES_BOOKMARK"
export const REMOVE_MOVIES_BOOKMARK = "REMOVE_MOVIES_BOOKMARK"
export const REMOVE_TV_SERIES_BOOKMARK = "REMOVE_TV_SERIES_BOOKMARK"
export const FETCH_MOVIES_SUCCESS = "FETCH_MOVIES_SUCCESS"
export const REQUEST_ACTION = "REQUEST_ACTION"


export const REQUEST_FETCH_BOOKMARK_MOVIES = "REQUEST_FETCH_BOOKMARK_MOVIES" 
export const REQUEST_FETCH_BOOKMARK_TV_SERIES = "REQUEST_FETCH_BOOKMARK_TV_SERIES" 


export const FETCH_BOOKMARK_MOVIES_SUCCESS = "FETCH_BOOKMARK_MOVIES_SUCCESS" 
export const FETCH_BOOKMARK_TV_SERIES_SUCCESS = "FETCH_BOOKMARK_TV_SERIES_SUCCESS" 


export const REQUEST_TRENDING_DATA_FETCH = "REQUEST_TRENDING_DATA_FETCH"
export const TRENDING_DATA_FETCH_COMPLETED = "TRENDING_DATA_FETCH_COMPLETED"
export const DATA_FETCH_FAILED = "DATA_FETCH_FAILED"


export const REQUEST_RECOMMENDED_DATA_FETCH = "REQUEST_RECOMMENDED_DATA_FETCH"
export const RECOMMENDED_DATA_FETCH_COMPLETED = "RECOMMENDED_DATA_FETCH_COMPLETED"
 
 
export const REQUEST_MOVIE_DATA_FETCH = "REQUEST_MOVIE_DATA_FETCH"
export const MOVIE_DATA_FETCH_COMPLETED = "MOVIE_DATA_FETCH_COMPLETED"
 
 
export const REQUEST_TVSERIES_DATA_FETCH = "REQUEST_TVSERIES_DATA_FETCH"
export const TVSERIES_DATA_FETCH_COMPLETED = "TVSERIES_DATA_FETCH_COMPLETED"
 
 
export const REQUEST_SINGLE_MOVIE_DATA_FETCH = "REQUEST_SINGLE_MOVIE_DATA_FETCH"
export const SINGLE_MOVIE_DATA_FETCH_COMPLETED = "SINGLE_MOVIE_DATA_FETCH_COMPLETED"
 
 
export const REQUEST_SINGLE_SERIES_DATA_FETCH = "REQUEST_SINGLE_SERIES_DATA_FETCH"
export const SINGLE_SERIES_DATA_FETCH_COMPLETED = "SINGLE_SERIES_DATA_FETCH_COMPLETED"
 
export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN_FAILURE="LOGIN_FAILURE";
export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const OAUTH_LOGIN_SUCCESS="OAUTH_LOGIN_SUCCESS";
 
export const SIGNUP_REQUEST="SIGNUP_REQUEST";
export const SIGNUP_FAILURE="SIGNUP_FAILURE";
export const SIGNUP_SUCCESS="SIGNUP_SUCCESS";

export const LOGOUT = "LOGOUT"
